import React from "react";
import { resolveVendorContactNotesDisplay } from "../utils/assessmentAdminFormHelpers";
import { normalizeContactEmail } from "../utils/assessmentAdminFieldConfig";

/**
 * Optional admin notes for a single assessment contact (vendor or sponsor).
 */
export default function OverviewContactNotesRow({
  contact,
  contactNotesByEmail = {},
  notesEditable = false,
  onNotesChange,
  idPrefix = "contact",
}) {
  const emailKey = normalizeContactEmail(contact?.email);
  if (!emailKey) return null;

  const notesDisplay = resolveVendorContactNotesDisplay(
    emailKey,
    contactNotesByEmail,
    contact
  );

  if (notesEditable) {
    return (
      <div className="mt-2 sm:max-w-xl">
        <label
          htmlFor={`${idPrefix}-notes-${emailKey}`}
          className="block text-xs font-medium text-gray-700"
        >
          Notes
        </label>
        <textarea
          id={`${idPrefix}-notes-${emailKey}`}
          rows={2}
          value={contactNotesByEmail[emailKey] ?? ""}
          onChange={(e) => onNotesChange?.(emailKey, e.target.value)}
          className="mt-1 block w-full rounded-md bg-white px-3 py-1.5 text-sm text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
          placeholder="Optional notes..."
        />
      </div>
    );
  }

  return (
    <div className="mt-1 text-xs text-gray-500 whitespace-pre-wrap sm:max-w-xl">
      <span className="font-medium text-gray-600">Notes: </span>
      {notesDisplay || "—"}
    </div>
  );
}
